import { useSceneEntities } from "@/stores/SceneEntities";
import { useUIRadioGroup } from "@/scripts/rooms/actions/general/UIRadioGroup";

import { useAssetRecessWindow } from "@/scripts/rooms/actions/alcove/AssetRecessWindow";
import { useAssetRecessSoap1 } from "@/scripts/rooms/actions/alcove/AssetRecessSoap1";
import { useAssetRecessSoap2 } from "@/scripts/rooms/actions/alcove/AssetRecessSoap2";
import { useAssetRecessSoap1Window } from "@/scripts/rooms/actions/alcove/AssetRecessSoap1Window";
import { useAssetRecessSoap2Window } from "@/scripts/rooms/actions/alcove/AssetRecessSoap2Window";
import { useAssetRecessSteelShelf1 } from "@/scripts/rooms/actions/alcove/AssetRecessSteelShelf1";
import { useAssetRecessSteelShelf2 } from "@/scripts/rooms/actions/alcove/AssetRecessSteelShelf2";
import { useAssetRecessCustomSoap1 } from "@/scripts/rooms/actions/alcove/AssetRecessCustomSoap1";
import { useAssetRecessCustomSoap2 } from "@/scripts/rooms/actions/alcove/AssetRecessCustomSoap2";

export function useAssetCornerShelves(payload, viewport) {
  // need to hide or show shelves , need to know if they metal or sentrel
  const sceneEntities = useSceneEntities();
  console.log(payload.enabled, payload.key)
  let useSentrelShelves = sceneEntities.getUIData("corner_shelf_sentrel_material").enabled;
  let key = payload.key;
  let keyCached = key;
  if (!useSentrelShelves) {
    if (key !== 'accessories_full_length_shelf') {
      key += "_metal";
    }

  }
  let asset = sceneEntities.configuratorView.viewportComponent.getViewportAsset(key);
  if (asset) {
    asset.enabled = payload.enabled;
    viewport.setEnabled(asset);
  }

  if (keyCached.includes('accessories_shelflefttop') || keyCached.includes('accessories_shelflrighttop')) {
    if (payload.enabled) {
      let fullLengthShelf = sceneEntities.getUIData("accessories_full_length_shelf")
      if (fullLengthShelf) {
        if (fullLengthShelf.enabled) {
          fullLengthShelf.enabled = false;
          let fullLengthShelfAsset = sceneEntities.configuratorView.viewportComponent.getViewportAsset("accessories_full_length_shelf");

          fullLengthShelfAsset.enabled = false
          viewport.setEnabled(fullLengthShelfAsset);
        }
      }

    }

  }
  if (keyCached.includes('accessories_full_length_shelf')) {
    if (payload.enabled) {
      let shelfLeftTop = sceneEntities.getUIData("accessories_shelflefttop");
      let shelfRightTop = sceneEntities.getUIData("accessories_shelfrighttop");

      shelfLeftTop.enabled = false;
      shelfRightTop.enabled = false;

      let shelfLeftTopAsset = sceneEntities.configuratorView.viewportComponent.getViewportAsset("accessories_shelflefttop");
      if (shelfLeftTopAsset) {
        shelfLeftTopAsset.enabled = false;
        viewport.setEnabled(shelfLeftTopAsset);
      }

      shelfLeftTopAsset = sceneEntities.configuratorView.viewportComponent.getViewportAsset("accessories_shelflefttop_metal");
      if (shelfLeftTopAsset) {
        shelfLeftTopAsset.enabled = false;
        viewport.setEnabled(shelfLeftTopAsset);
      }


      let shelfRightTopAsset = sceneEntities.configuratorView.viewportComponent.getViewportAsset("accessories_shelfrighttop");
      if (shelfRightTopAsset) {
        shelfRightTopAsset.enabled = false;
        viewport.setEnabled(shelfRightTopAsset);
      }

      shelfRightTopAsset = sceneEntities.configuratorView.viewportComponent.getViewportAsset("accessories_shelfrighttop_metal");
      if (shelfRightTopAsset) {
        shelfRightTopAsset.enabled = false;
        viewport.setEnabled(shelfRightTopAsset);
      }

      let accessories_recess_regular = sceneEntities.getUIData("accessories_recess_regular");
      if (!accessories_recess_regular.enabled) {

        accessories_recess_regular.enabled = true
        let previousSelection = useUIRadioGroup(accessories_recess_regular);

        let wallsfull = sceneEntities.getUIData("wallsfull").enabled;
        let walls34 = sceneEntities.getUIData("walls34").enabled;

        let interactionFunctions = {};
        //recess window
        interactionFunctions.accessories_recess_window = useAssetRecessWindow;
        //recess soap 1
        interactionFunctions.accessories_recess_soap1 = useAssetRecessSoap1;
        //recess soap 2
        interactionFunctions.accessories_recess_soap2 = useAssetRecessSoap2;
        //recess soap 1 window
        interactionFunctions.accessories_recess_soap1window = useAssetRecessSoap1Window;
        //recess soap 2 window
        interactionFunctions.accessories_recess_soap2window = useAssetRecessSoap2Window;
        //recess steel shelf 1
        interactionFunctions.accessories_recess_steelshelf1 = useAssetRecessSteelShelf1;
        //recess steel shelf 2
        interactionFunctions.accessories_recess_steelshelf2 = useAssetRecessSteelShelf2;
        //recess custom soap 1
        interactionFunctions.accessories_recess_custom_soap_1 = useAssetRecessCustomSoap1;
        //recess custom soap 2
        interactionFunctions.accessories_recess_custom_soap_2 = useAssetRecessCustomSoap2;
        if (previousSelection) {
          let f = interactionFunctions[previousSelection.key];
          if (f) {
            f(previousSelection, viewport);
          }
        }

        let wall1 = sceneEntities.configuratorView.viewportComponent.getViewportAsset("wall_interior_center_full");
        let wall2 = sceneEntities.configuratorView.viewportComponent.getViewportAsset("wall_interior_center_34");
        if (wallsfull) {
          wall1.enabled = true;
          viewport.setEnabled(wall1);

          wall2.enabled = false;
          viewport.setEnabled(wall2);
        }
        if (walls34) {
          wall1.enabled = false;
          viewport.setEnabled(wall1);

          wall2.enabled = true;
          viewport.setEnabled(wall2);
        }

      }

    }





  }
}
